import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function ProductEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function ProductCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"product"} children={children} />
    );
}